<template>
  <div :class="{ 'fade modal-open' : isModalOpen }" class="modal in" @click.self.stop="closeModal" v-if="item">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal__header" :class="headerClasses">
          <HeaderItem v-if="header" :header="header" :is-last="isLast" :is-first="isFirst"></HeaderItem>
        </div>
        <div class="modal-body">
          <component v-bind:is="itemType" :item="item"></component>
          <CommentsContainer></CommentsContainer>
        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import WorkOrder from './modal-items/WorkOrder.vue';
  import GenericItem from './modal-items/GenericItem.vue';
  import HeaderItem from './modal-items/HeaderItem.vue';
  import CommentsContainer from './modal-items/comments/CommentsContainer.vue';


  export default {
    name: 'AgendaItemModal',
    components: {
      WorkOrder,
      GenericItem,
      HeaderItem,
      CommentsContainer,
    },
    props: {
      headerClass: '',
    },
    mounted() {
      const component = this;
      this.handler = function (e) {
        if (e.code === 'Escape') {
          component.closeModal();
        }
      }
      window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },
    computed: {
      ...mapGetters('meetingAgendas', [
        'modalActive',
        'currentAgendaItems',
        'currentAgendaItemIndex',
        'currentHeaderItemIndex',
        'currentAgendaItem',
        'currentHeaderItem',
      ]),
      item() {
        return this.currentAgendaItem;
      },
      header() {
        return this.currentHeaderItem;
      },
      itemType() {
        if (this.item.hasOwnProperty('work_order_id')) {
          return 'WorkOrder';
        }
        return this.item.type;
      },
      hasHeader() {
        return this.header !== null && this.header !== undefined;
      },
      isFirst() {
        return this.currentAgendaItemIndex === 0 || this.currentAgendaItemIndex === 1 && this.currentHeaderItemIndex === 0;
      },
      isLast() {
        return this.currentAgendaItemIndex === (this.currentAgendaItems.length - 1);
      },
      isModalOpen() {
        return true;
      },
      headerClasses() {
        return `modal__header--${this.headerClass}`;
      },
    },
    methods: {
      closeModal() {
        this.$store.dispatch('meetingAgendas/closeModal');
      },
      nextItem() {
        this.$store.dispatch('meetingAgendas/nextItem');
      },
      prevItem() {
        this.$store.dispatch('meetingAgendas/prevItem');
      }
    },
  };
</script>
